var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Model, validator, TransformValidateModel, } from "@musicaudienceexchange/toccata";
export class LobbyColors extends Model {
}
__decorate([
    validator.IsOptional(),
    validator.IsString()
], LobbyColors.prototype, "artist", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], LobbyColors.prototype, "copyright", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], LobbyColors.prototype, "date", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], LobbyColors.prototype, "footerLinks", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], LobbyColors.prototype, "header", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], LobbyColors.prototype, "headerActions", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], LobbyColors.prototype, "label", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], LobbyColors.prototype, "legal", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], LobbyColors.prototype, "page", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], LobbyColors.prototype, "venue", void 0);
export class LobbyPage extends Model {
}
__decorate([
    validator.IsOptional(),
    validator.IsString()
], LobbyPage.prototype, "joinButton", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], LobbyPage.prototype, "cancelButton", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], LobbyPage.prototype, "splashImage", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsBoolean()
], LobbyPage.prototype, "disableAvatar", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsBoolean()
], LobbyPage.prototype, "disableText", void 0);
__decorate([
    validator.IsOptional(),
    TransformValidateModel(LobbyColors)
], LobbyPage.prototype, "colors", void 0);
export class LandingBlockColors extends Model {
}
__decorate([
    validator.IsOptional(),
    validator.IsString()
], LandingBlockColors.prototype, "background", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], LandingBlockColors.prototype, "body", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], LandingBlockColors.prototype, "button", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], LandingBlockColors.prototype, "buttonBorder", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], LandingBlockColors.prototype, "buttonText", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], LandingBlockColors.prototype, "title", void 0);
export class LandingColors extends Model {
}
__decorate([
    validator.IsOptional(),
    validator.IsString()
], LandingColors.prototype, "button", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], LandingColors.prototype, "buttonBorder", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], LandingColors.prototype, "buttonText", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], LandingColors.prototype, "copyright", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], LandingColors.prototype, "footerLinks", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], LandingColors.prototype, "headerActions", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], LandingColors.prototype, "page", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], LandingColors.prototype, "title", void 0);
__decorate([
    validator.IsOptional(),
    TransformValidateModel(LandingBlockColors)
], LandingColors.prototype, "blocks", void 0);
export class LandingBlock extends Model {
}
__decorate([
    validator.IsOptional(),
    validator.IsString()
], LandingBlock.prototype, "image", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], LandingBlock.prototype, "title", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], LandingBlock.prototype, "body", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], LandingBlock.prototype, "button", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], LandingBlock.prototype, "link", void 0);
export class LandingPage extends Model {
}
__decorate([
    validator.IsOptional(),
    validator.IsString()
], LandingPage.prototype, "title", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], LandingPage.prototype, "button", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], LandingPage.prototype, "buttonLoading", void 0);
__decorate([
    validator.IsOptional(),
    TransformValidateModel(LandingBlock, { each: true })
], LandingPage.prototype, "blocks", void 0);
__decorate([
    validator.IsOptional(),
    TransformValidateModel(LandingColors)
], LandingPage.prototype, "colors", void 0);
export class LogoImage extends Model {
}
__decorate([
    validator.IsOptional(),
    validator.IsString()
], LogoImage.prototype, "path", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], LogoImage.prototype, "width", void 0);
export class Logos extends Model {
}
__decorate([
    validator.IsOptional(),
    TransformValidateModel(LogoImage)
], Logos.prototype, "landing", void 0);
__decorate([
    validator.IsOptional(),
    TransformValidateModel(LogoImage)
], Logos.prototype, "event", void 0);
__decorate([
    validator.IsOptional(),
    TransformValidateModel(LogoImage)
], Logos.prototype, "dark", void 0);
export class InputColors extends Model {
}
__decorate([
    validator.IsOptional(),
    validator.IsString()
], InputColors.prototype, "background", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], InputColors.prototype, "border", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], InputColors.prototype, "text", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], InputColors.prototype, "font", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], InputColors.prototype, "placeholder", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], InputColors.prototype, "placeholderFont", void 0);
export class GlobalColors extends Model {
}
__decorate([
    validator.IsOptional(),
    validator.IsString()
], GlobalColors.prototype, "action", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], GlobalColors.prototype, "actionLabel", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], GlobalColors.prototype, "actionSecondary", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], GlobalColors.prototype, "actionSecondaryLabel", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], GlobalColors.prototype, "actionSecondaryBorder", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], GlobalColors.prototype, "actionComplete", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], GlobalColors.prototype, "modalAction", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], GlobalColors.prototype, "modalActionLabel", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], GlobalColors.prototype, "modalSecondaryAction", void 0);
__decorate([
    validator.IsOptional(),
    TransformValidateModel(InputColors)
], GlobalColors.prototype, "input", void 0);
export class EventTabColors extends Model {
}
__decorate([
    validator.IsOptional(),
    validator.IsString()
], EventTabColors.prototype, "activeBackground", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], EventTabColors.prototype, "activeText", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], EventTabColors.prototype, "inactiveBackground", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], EventTabColors.prototype, "inactiveText", void 0);
export class EventColors extends Model {
}
__decorate([
    validator.IsOptional(),
    validator.IsString()
], EventColors.prototype, "header", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], EventColors.prototype, "headerActions", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], EventColors.prototype, "page", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], EventColors.prototype, "artist", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], EventColors.prototype, "venue", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], EventColors.prototype, "date", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], EventColors.prototype, "divider", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], EventColors.prototype, "title", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], EventColors.prototype, "description", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], EventColors.prototype, "body", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], EventColors.prototype, "caption", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], EventColors.prototype, "action", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], EventColors.prototype, "actionLabel", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], EventColors.prototype, "modalAction", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], EventColors.prototype, "modalActionLabel", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], EventColors.prototype, "modalSecondaryAction", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], EventColors.prototype, "listTitle", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], EventColors.prototype, "listSubtitle", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], EventColors.prototype, "listDivider", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], EventColors.prototype, "progressBar", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], EventColors.prototype, "progressBarBackground", void 0);
__decorate([
    validator.IsOptional(),
    TransformValidateModel(EventTabColors)
], EventColors.prototype, "tabs", void 0);
export class EventPage extends Model {
}
__decorate([
    validator.IsOptional(),
    validator.IsBoolean()
], EventPage.prototype, "bannerGradientOffset", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], EventPage.prototype, "bannerTextDropShadow", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsBoolean()
], EventPage.prototype, "bannerHeight", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsBoolean()
], EventPage.prototype, "disableImageBlur", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], EventPage.prototype, "exitButtonText", void 0);
__decorate([
    validator.IsOptional(),
    TransformValidateModel(EventColors)
], EventPage.prototype, "colors", void 0);
export class AddonLink extends Model {
}
__decorate([
    validator.IsString()
], AddonLink.prototype, "text", void 0);
__decorate([
    validator.IsString()
], AddonLink.prototype, "link", void 0);
export class Footer extends Model {
}
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Footer.prototype, "copyright", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Footer.prototype, "termsOfUseUrl", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Footer.prototype, "privacyPolicyUrl", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsBoolean()
], Footer.prototype, "hideDefaultLinks", void 0);
__decorate([
    validator.IsOptional(),
    TransformValidateModel(AddonLink, { each: true })
], Footer.prototype, "addonLinks", void 0);
export class Branding extends Model {
}
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Branding.prototype, "groupId", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Branding.prototype, "brandingId", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Branding.prototype, "brand", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Branding.prototype, "logo", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Branding.prototype, "logoAlt", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Branding.prototype, "logoLarge", void 0);
__decorate([
    validator.IsOptional(),
    TransformValidateModel(Logos)
], Branding.prototype, "logos", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Branding.prototype, "headerFont", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Branding.prototype, "bodyFont", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Branding.prototype, "googleFontUrl", void 0);
__decorate([
    validator.IsOptional(),
    TransformValidateModel(GlobalColors)
], Branding.prototype, "colors", void 0);
__decorate([
    validator.IsOptional(),
    TransformValidateModel(LandingPage)
], Branding.prototype, "landing", void 0);
__decorate([
    validator.IsOptional(),
    TransformValidateModel(LobbyPage)
], Branding.prototype, "lobby", void 0);
__decorate([
    validator.IsOptional(),
    TransformValidateModel(EventPage)
], Branding.prototype, "event", void 0);
__decorate([
    validator.IsOptional(),
    TransformValidateModel(Footer)
], Branding.prototype, "footer", void 0);
//# sourceMappingURL=branding.js.map